import React from "react";
import { Form, Row, Col, Card } from "react-bootstrap";
import { defineMessages, useIntl } from "react-intl";
import Select from "react-select";

const messages = defineMessages({
  selectFolder: {
    id: "modules.ArriVideo.components.Broadcasts.selectFolder",
    description: "Select a folder",
    defaultMessage: "Select a folder",
  },
  noFolder: {
    id: "modules.ArriVideo.components.Broadcasts.noFolder",
    description: "No folder label.",
    defaultMessage: "No folder",
  },
  titleFilter: {
    id: "modules.Arrivideo.components.Broadcasts.titleFilter",
    description: "Filter on title message",
    defaultMessage: "filter on title",
  },
  folderFilter: {
    id: "modules.Arrivideo.components.Broadcasts.folderFilter",
    description: "Filter on folder message",
    defaultMessage: "filter on folder",
  },
  search: {
    id: "modules.EmailEstablishment.components.Establishments.search",
    description: "Search helper message",
    defaultMessage: "Search is not case sensitive",
  },
  titleSearch: {
    id: "modules.Arrivideo.components.Broadcasts.titleSearch",
    description: "Search on title message",
    defaultMessage: "Enter a title to search",
  },
});

const SearchBroadcastForm = ({
  folders,
  searchTitle,
  setSearchTitle,
  setSearchFolder,
}) => {
  const intl = useIntl();

  const folderOptions = [
    { value: -1, label: intl.formatMessage(messages.noFolder) },
  ];

  if (folders && folders.length > 0) {
    folders.forEach((folder) => {
      folderOptions.push({
        value: folder.id,
        label: folder.title,
      });
    });
  }

  return (
    <Card bg="light" className="mb-4">
      <Card.Body>
        <Form>
          <Row>
            <Col xs={12} md={8} lg={8}>
              <Form.Group controlId="searchFormTitle">
                <Form.Label>
                  {intl.formatMessage(messages.titleFilter)}
                </Form.Label>
                <Form.Control
                  style={{ width: 450 }}
                  type="text"
                  value={searchTitle || ""}
                  placeholder={intl.formatMessage(messages.titleSearch)}
                  onChange={(e) => {
                    setSearchTitle(e.target.value);
                  }}
                  className="mb-2"
                />
                <Form.Text>{intl.formatMessage(messages.search)}</Form.Text>
              </Form.Group>
            </Col>
            {folderOptions && folderOptions.length > 1 && (
              <Col
                xs={12}
                md={{ span: 3, offset: 1 }}
                lg={{ span: 3, offset: 1 }}
              >
                <Form.Group controlId="searchFormFolder">
                  <Form.Label>
                    {intl.formatMessage(messages.folderFilter)}
                  </Form.Label>
                  <Select
                    isClearable
                    placeholder={intl.formatMessage(messages.selectFolder)}
                    options={folderOptions}
                    onChange={(option) => {
                      setSearchFolder(
                        option === null ? undefined : option.value,
                      );
                    }}
                  />
                </Form.Group>
              </Col>
            )}
          </Row>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default SearchBroadcastForm;
